import { render } from "./LinkCustomersToCustomerDiscountGroup.html?vue&type=template&id=024b258a&scoped=true"
import script from "./LinkCustomersToCustomerDiscountGroup.js?vue&type=script&lang=js"
export * from "./LinkCustomersToCustomerDiscountGroup.js?vue&type=script&lang=js"

import "./LinkCustomersToCustomerDiscountGroup.css?vue&type=style&index=0&id=024b258a&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-024b258a"]])

export default __exports__